// extracted by mini-css-extract-plugin
export var actions = "_1k-0";
export var actionsContainer = "_1k-7";
export var border = "_1k-1";
export var childFullHeight = "_1k-e";
export var collapse = "_1k-2";
export var content = "_1k-9";
export var contentChild = "_1k-d";
export var fullscreen = "_1k-b";
export var hasLeftRadius = "_1k-j";
export var headerContainer = "_1k-3";
export var headerRow = "_1k-5";
export var hidePadding = "_1k-a";
export var navCollapsedGap = "_1k-k";
export var noScrollX = "_1k-l";
export var noScrollY = "_1k-m";
export var noTopPadding = "_1k-h";
export var optOutTopPadding = "_1k-c";
export var pageMain = "_1k-i";
export var pageOuter = "_1k-f";
export var pagePadding = "_1k-8";
export var profile = "_1k-n";
export var profileContainer = "_1k-o";
export var profileImage = "_1k-p";
export var profileMain = "_1k-q";
export var profileSubtitle = "_1k-s";
export var profileTitle = "_1k-r";
export var showLeftPadding = "_1k-g";
export var tabsPortalSlot = "_1k-6";
export var tabsWrapper = "_1k-4";
export var title = "_1k-t";